<div class="d-flex flex-column month-grid">
  <div class="d-flex flex-row align-items-stretch month-grid-body">
    @for (column of year.monthColumns; track column.month) {
      <div [class]="'d-flex flex-column align-items-center gap-1 month-column month-' + column.month">
        <strong class="month-label">{{ column.label }}</strong>
        @for (event of visibleEvents(column); track event.bank + event.date) {
          <div class="d-flex flex-column align-items-center event"
            [style.color]="bankColor(event.bank)">
            <span class="d-flex flex-row align-items-baseline justify-content-center flex-wrap event-line">
              <span class="event-bank">{{ event.bank }}</span>
              <span class="event-date">
                @if (event.hasProjections) {<span class="event-star" aria-label="Economic projections">★</span>}
                {{ event.dateLabel }}
              </span>
            </span>
            @if (event.changeLabel) {
              <span class="event-change">{{ event.changeLabel }}</span>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
